import { useRef } from 'react';

export interface EscapeClosesPopupOnly {
  /** Snapshot whether the popup was open before react-aria handles the key (and closes it). */
  onKeyDownCapture: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  /** Keep that Escape from reaching an enclosing drawer/dialog. */
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

/**
 * Escape with the popup open closes ONLY the popup; with it closed Escape is left alone so an enclosing SideDrawer / Dialog still closes. react-aria's combobox keeps Escape propagating when `allowsCustomValue` is set (ours always is).
 * Open state is read from `aria-expanded` in the CAPTURE phase (react-aria closes the popup in its own handler); propagation is stopped in the BUBBLE phase so react-aria's text-revert handler still runs.
 */
export function useEscapeClosesPopupOnly(): EscapeClosesPopupOnly {
  const popupWasOpenRef = useRef(false);

  return {
    onKeyDownCapture: (e) => {
      popupWasOpenRef.current = e.key === 'Escape' && e.currentTarget.getAttribute('aria-expanded') === 'true';
    },
    onKeyDown: (e) => {
      if (e.key !== 'Escape' || !popupWasOpenRef.current) return;
      popupWasOpenRef.current = false;
      e.stopPropagation();
    },
  };
}
